export default __webpack_public_path__ + "static/media/servicebench-logo.e13f950b.png";